import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import axios from 'axios'
import store from './store'
import VueElementLoading from 'vue-element-loading'
import SnackBar from './components/Common/snackBar'
import ServerError from './components/Common/500'
import ImageLoader from './components/Common/imageLoader'
import PageLoader from './components/Common/pageLoader'
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)
import viewer from 'v-viewer'
Vue.use(viewer)
import ImageMagnifier from 'vue-image-magnifier'
Vue.use(ImageMagnifier)

import OwlCarousel from 'vue-owl-carousel'

// import VueSocialSharing from 'vue-social-sharing'
// import VueTimeago from 'vue-timeago'
// Vue.use(VueTimeago, {
//     name: 'Timeago', // Component name, `Timeago` by default
//     locale: 'en', // Default locale
//     // We use `date-fns` under the hood
//     // So you can use all locales from it
//     locales: {
//         'zh-CN': require('date-fns/locale/zh_cn'),
//         ja: require('date-fns/locale/ja')
//     }
// })

import VueTimeago from 'vue-timeago'

Vue.use(VueTimeago, {
  name: 'Timeago', // Component name, `Timeago` by default
  locale: 'en', // Default locale
  // We use `date-fns` under the hood
  // So you can use all locales from it
  locales: {
    // 'zh-CN': require('date-fns/locale/zh_cn'),
    ja: require('date-fns/locale/ja')
  }
})

Vue.component('apexchart', VueApexCharts)
Vue.component('OwlCarousel', OwlCarousel)
Vue.component('ServerError', ServerError)
Vue.component('SnackBar', SnackBar)
Vue.component('ImageLoader', ImageLoader)
Vue.component('PageLoader', PageLoader)
Vue.component('VueElementLoading', VueElementLoading)

Vue.config.productionTip = false
window.axios = require('axios')
// axios.defaults.baseURL = 'http://192.168.48.198:3300';
// axios.defaults.baseURL = 'http://192.168.50.52:5000';
// Vue.prototype.baseURL = "http://192.168.50.52:5000"

// axios.defaults.baseURL = 'http://13.235.115.229';
axios.defaults.baseURL = 'https://api.agogoai.com';
Vue.prototype.baseURL = "https://api.agogoai.com"
// Vue.prototype.mediaURLOld = "https://192.168.48.198:3700/u/"
Vue.prototype.mediaURL = "https://api.agogoai.com/wp/"
// Vue.prototype.mediaURL = "http://13.235.115.229/file/get/"
Vue.prototype.appColor = '#FC4B4B'
Vue.mixin({
  data() {
    return {
      webpSupported: true,
    };
  },

  created() {
    (async () => {
      // If browser doesn't have createImageBitmap, we can't use webp.
      if (!self.createImageBitmap) {
        this.webpSupported = false;
        return;
      }
      // Base64 representation of a white point image
      const webpData =
        "data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoCAAEAAQAcJaQAA3AA/v3AgAA=";
      // Retrieve the Image in Blob Format
      const blob = await fetch(webpData).then((r) => r.blob());
      // If the createImageBitmap method succeeds, return true, otherwise false
      this.webpSupported = await createImageBitmap(blob).then(
        () => true,
        () => false
      );
      if (this.webpSupported) {
        Vue.prototype.mediaURL = "https://api.agogoai.com/wp/";
      } else {
        Vue.prototype.mediaURL = "https://api.agogoai.com/wp/";

      }
    })();
  },
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
